//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "marionette",
  "messaging/messenger",
  "./siteMapUploadsView",
  "modules/upload/contentUploadModel",
], function (Marionette, Messenger, SiteMapUploadsView, ContentUploadModel) {
  "use strict";

  var SiteMapUploadsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "siteMapUploads";
      this.region = options.region;
    },
    show: function (siteMap, siteMapUploads) {
      this.siteMap = siteMap;
      this.siteMapUploads = siteMapUploads;
      this.view = new SiteMapUploadsView.siteMapUploadsView({ collection: siteMapUploads });
      this.view.on("add:upload", this._onAddUpload, this);
      this.view.on("itemview:delete:upload", this._onDeleteUpload, this);
      this.showRegion(this.view);
      siteMapUploads.onSynced(function () {
        this.view.render();
      }, this);
    },
    _onAddUpload: function (file, form) {
      if (!file || !form) {
        return;
      }
      // NOTE: The input for the template already includes accept="text/html" so the browser should already
      // limit uploads to HTML files.
      var fileName = file.name;
      var fileSize = file.size;
      if (fileSize > ContentUploadModel.contentUpload.MAX_SIZE) {
        Messenger.okDialog("content.dialog.tooLarge");
        console.log("File size exceeds maximum allowed");
        return;
      }
      var touchPointIds = this.siteMap.get("touchPointIds");
      if (!touchPointIds || !touchPointIds.length) {
        Messenger.okDialog("admin.siteMaps.touchPointsEmptyError");
        console.log("No TouchPoints were added to the Site Map");
        return;
      }
      //upload the file to the upload server
      var uploadModel = new ContentUploadModel.contentUpload({
        kbId: this.siteMap.get("kbId"),
        languageId: this.siteMap.get("languageId"),
        touchPointId: touchPointIds[0],
      });
      Messenger.vent.once(
        "content:upload:changed",
        function (isSuccess, fileName, fileSize, isUploaded, uploadId) {
          if (isSuccess) {
            var data = {
              uploadFileName: fileName,
              uploadId: uploadId,
            };
            if (!this.siteMap.isNew()) {
              data.siteMapId = this.siteMap.get("id");
            }
            this.siteMapUploads.addItem(data);
          }
        },
        this,
      );
      Messenger.reqres.request("upload:content", form, fileName, fileSize, uploadModel);
    },
    _onDeleteUpload: function (itemView) {
      Messenger.yesNoDialog("admin.siteMaps.uploads.confirmDelete", {
        yes: function () {
          Messenger.vent.trigger("track:interaction", {
            action: "Delete Site Map",
            id: itemView.model.id,
            idType: "Site Map",
            object: "Site Map",
          });
          itemView.model.deleteModel();
          Messenger.vent.trigger("cancel:textbox");
        },
      });
    },
  });

  return SiteMapUploadsController;
});
